import {INTERNAL_ANALYTICS_UUID} from './serve/consts';
import {get, set} from './serve/localStorage';

export function getUuid() {
  return get<string>(INTERNAL_ANALYTICS_UUID);
}

export function setUuid(uid: string): void {
  set(INTERNAL_ANALYTICS_UUID, uid);
}
